<div id="notary-container">
  <div id="content-container">
    <h1 class="card-header"> {{ 'NOTARY_CALCULATOR' | translate | uppercase}} </h1>
    <div id="notary-content">
      <div id="notary-text">{{ 'NOTARY_CALCULATOR_TOP_TEXT' | translate }}</div>
      <div id="form">
        <label for="contract-value" id="contract-value-text">{{ 'VALUE_OF_DEAL' | translate}}</label>
        <input #input type="number" id="contract-value" (input)="onValueUpdate(input)">
        <div id="currency">{{ 'BGN' | translate}}</div>
      </div>
      <div id="notary-calculations">
        <div class="tax">
          <div id="notary-tax">{{ 'NOTARIAL_FEE' | translate }}</div>
          <div class="value">{{notaryTax}} {{ 'BGN' | translate }}</div>
        </div>
        <div class="tax">
          <div id="registration-tax">{{ 'REGISTER_FEE' | translate }}</div>
          <div class="value">{{registrationTax}} {{ 'BGN' | translate }}</div>
        </div>
        <div class="tax">
          <div id="council-tax">{{ 'AREA_FEE' | translate}}</div>
          <div class="value">{{councilTax}} {{ 'BGN' | translate}}</div>
        </div>
        <div class="tax">
          <div id="total">{{ 'TOTAL_FEE' | translate}}</div>
          <div class="value">{{totalTax}} {{ 'BGN' | translate}}</div>
        </div>
      </div>
    </div>
  </div>
</div>
